<style lang='less' scoped >
.navmenu{position: relative;}
li {list-style-type:none;}
.had_top{display: flex; justify-content:space-between;align-items:center;height:120px;padding: 10px 0; width: 1200px;margin: auto;padding: 0;}
.headnev{display: flex; width:100%;position: relative;flex-direction: column;background: url('../../../../static/index/header.png') no-repeat; background-size: 100% 100%;}
.logo{height: 60px;width: 270px;color:#fff;margin-top:10px; margin-top: 26px;margin-right: 370px;padding-left: 10px;}
.logo h3{border-bottom: 1px solid white;margin: 0;}
.logo h4{margin: 0;}
.login{width:550px;height:0px;position: relative;left: 700px;}
.login span{padding: 0 15px;color:#fff;cursor: pointer;}
.login .span_bor{border-right: 1px solid #fff;    line-height: 15px;}
img{width:50px}
.menu{display: flex; width:100%;position: relative;flex-direction: column;background: url('../../../../static/index/menu.png') no-repeat; background-size: 100% 100%;}
a {color: #fff!important;}
</style>
<template>
   <div class="navmenu" id="start">
    <div class="top_adt">
      <!-- <a href="" style="width:100%">
        <img :src="img" style="width:100%; vertical-align: middle;" alt="">
      </a> -->
    </div>
    <div class="headnev">
      <div class="had_top">
        <div class="login">
          <span class="span_bor" v-if="username === ''">
            <router-link to="/LoginIndex">登录</router-link>
          </span>
          <span class="span_bor">
            <router-link to="/KyforumApp">网站首页</router-link>
          </span>
          <span class="span_bor" @click="onclickEng">English</span>
          <span class="span_bor">
            <router-link to="/Gywm">关于我们</router-link>
          </span>
          <span class="span_bor">
            <router-link to="/Members">
              {{ msg }}
            </router-link>
          </span>
          <span @click="exit()">
            退出
          </span>
        </div>
      </div>
    </div>
    <MenuPanelApp :menulist="menulist" class="menu"></MenuPanelApp>
  </div>
</template>

<script>
/**
 * 罗志远-矿业论坛头部导航栏
 */
import MenuPanelApp from './MenuPanelApp.vue'
export default {
  inject: ['reload'],
  components: {MenuPanelApp},
  data()
  {
    return {
      img: 'static/index/topnav.jpg',
      menulist:
      [
        {grp: '', namee: 'PromoinApp', namec: '矿业论坛首页', target: 'menu', sort: '1'},
        {grp: '', namee: 'dhxw', namec: '大会新闻', target: 'menu', sort: '2'},
        {grp: '', namee: 'hyrc', namec: '会议日程', target: 'menu', sort: '3'},
        {grp: '', namee: 'yjjb', namec: '演讲嘉宾', target: 'menu', sort: '4'},
        {grp: '', namee: 'chbm', namec: '参会报名', target: 'menu', sort: '5'}
      ],
      msg: '会员中心',
      username: ''
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        document.querySelector('#start') && document.querySelector('#start').scrollIntoView({ block: 'start' })
      },
      immediate: true,
      deep: true
    }
  },
  created()
  {
    this.getusername()
  },
  methods:
  {
    exit()
    {
      this.reload()
      localStorage.removeItem('username')
      this.$router.push({path: '/loginIndex'})
    },
    onclickEng()
    {
      window.open('https://www.camining.cn/en/index.html', '_blank')
    },
    getusername()
    {
      if (localStorage.getItem('username'))
      {
        this.username = localStorage.getItem('username')
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 28,
          _exp: `username = '${localStorage.getItem('username')}'`
        }
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length === 1)
            this.msg = `欢迎，${ret[0].passport}`
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/layout/KYhadnavApp.vue